import { Box } from '@mui/material';
import React from 'react';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { MediaTypes } from '../../../../../../commands/practitioner/enums/MediaTypes';
import useMediaContext from '../../../../../../hooks/useMediaContextHook/useMediaContext';
import { PsylarisListItemStyle } from './style';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

interface PsylarisListItemProps {
  itemIndex: number;
  title: string;
  videoURL: string;
  imgCategoryUrl: string;
  onClickHandler: (idx: number) => void;
  detail: string;
  ThumbnailURL: string;
  stereoMode: string;
  selected: boolean;
}

export function PsylarisListItem(props: PsylarisListItemProps) {
  let { itemIndex, title, onClickHandler, videoURL, detail, ThumbnailURL, selected } = props;
  const { psylarisListItem } = PsylarisListItemStyle;
  const { setPractitionerMediaType } = usePractitionerControlsContext();
  const {
    setPsylarisDetailModal,
    setPsylarisDetailInfo,
    setDetailTitle,
    setDetailPreview,
    setSelectedItemURL,
    firstDiveInd,
    setFirstDiveInd,
    lastDiveIndex,
    setOriginalMediaURL,
    setMediaPopperVideo,
  } = useMediaContext();

  const selectedItem = (index: number) => {
    if (!!videoURL) {
      // Generate a unique URL by appending a timestamp to force re-rendering
      const updatedURL = `${addWebToUrl(videoURL)}?t=${Date.now()}`;
      // Update the original media URL and selected item URL
      setOriginalMediaURL(addWebToUrl(videoURL)); // Set original URL without timestamp
      setSelectedItemURL(updatedURL); // Use timestamped URL to trigger re-render
      setPractitionerMediaType(MediaTypes.VIDEO);
      setMediaPopperVideo(true); // Ensure media playback is enabled
    }
  };

  const addWebToUrl = (url: string): string => {
    let index = url.lastIndexOf('.mp4');
    let newUrl = url.slice(0, index) + '_web' + url.slice(index);
    return newUrl;
  };

  const onMouseEnter = () => {
    if (!firstDiveInd && lastDiveIndex) {
      setDetailPreview(ThumbnailURL);
      setDetailTitle(title);
      setPsylarisDetailInfo(detail);
      setPsylarisDetailModal(true);
    }
    setFirstDiveInd(false);
  };

  const onMouseLeave = () => {
    setPsylarisDetailInfo('');
    setPsylarisDetailModal(false);
    setDetailPreview('');
    setDetailTitle('');
    setMediaPopperVideo(false);
  };

  return (
    <Box
      sx={psylarisListItem}
      onClick={() => onClickHandler(itemIndex)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${selected ? 'selected' : ''}`}
    >
      <ListItemButton className="list-button" onClick={() => selectedItem(itemIndex)}>
        <ListItemIcon className={selected ? 'list-icon-selected' : 'list-icon'}>
          <OndemandVideoIcon />
        </ListItemIcon>
        <ListItemText className={selected ? 'list-text-selected' : 'list-text'} primary={title} />
      </ListItemButton>
    </Box>
  );
}
